import type { LoadOptionsWrapperType } from './types'
import type { BaseOptionType } from '../Select/types'
import type { ShouldLoadMore } from 'react-select-async-paginate'

export const shouldLoadMore: ShouldLoadMore = (
  scrollHeight,
  clientHeight,
  scrollTop
) => {
  const bottomBorder = (scrollHeight - clientHeight) / 2

  return bottomBorder < scrollTop
}

export const loadOptionsWrapper: LoadOptionsWrapperType<
  BaseOptionType<number | string>,
  unknown
> = (request) => async (search, prevOptions, additional) => {
  const result = await request(
    {
      search,
      offset: prevOptions.length,
    },
    additional
  )
  return {
    options: result.options,
    hasMore: result.hasMore,
    additional: result?.additional,
  }
}
